"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const TileDrawingTableRowItem = React.memo(({ row }) => {
    const rowItems = React.useMemo(() => {
        const { fileSize, url } = row, rest = tslib_1.__rest(row, ["fileSize", "url"]);
        const items = Object.entries(rest).map(([key, value]) => ({ key, value }));
        if (fileSize && url) {
            items.push({ key: 'download', value: fileSize, url });
        }
        return items;
    }, [row]);
    return ((0, jsx_runtime_1.jsx)("tr", { className: "", children: rowItems.map(({ key, value, url }) => ((0, jsx_runtime_1.jsx)("td", { className: (0, app_1.cn)('first:w-[36%]', key === 'download' && 'whitespace-nowrap !align-middle', (key === 'type' || key === 'updatedDate' || key === 'fileType') &&
                'hidden md:table-cell'), children: key === 'download' ? ((0, jsx_runtime_1.jsxs)("a", { href: url, download: true, className: "flex items-center hover:text-bg-accent-01-primary", target: "_blank", rel: "noreferrer", children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "download", className: "icon-download text-bg-accent-01-primary relative mr-2" }), value] })) : (value) }, key))) }));
});
exports.default = TileDrawingTableRowItem;
